import * as React from 'react';
import * as PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { SelectWrapper, SelectStyled, SelectIcon } from './styled';
import { Icon } from './../Icon';

interface OptionProps {
  value?: string | number;
  label?: string;
}

interface Props {
  name?: string;
  placeholder?: string;
  disabled?: boolean;
  error?: boolean;
  width?: string;
  fullWidth?: boolean;
  selected?: string | number;
  options: OptionProps[];
  onChange?: Function;
  uncontrolled?: boolean;
}

export const Select: React.FC<Props> = React.forwardRef(({
  name,
  placeholder,
  disabled,
  error,
  width,
  fullWidth,
  selected,
  options,
  onChange,
  uncontrolled,
  ...nextProps
}, ref) => {
  const propsRef = ref && (ref.hasOwnProperty('current') || typeof ref === 'function') ? { ref } : {}
  const [ value, setValue ] = useState(selected);

  useEffect(() => {
    uncontrolled && setValue(selected);
  });

  const handleChange = (e) => {
    setValue(e.target.value);
    onChange && onChange(e);
  };

  return (
    <SelectWrapper
      disabled={disabled}
      fullWidth={fullWidth}
      width={width}>
      <SelectStyled
        name={name}
        error={error}
        value={value}
        onChange={handleChange}
        {...nextProps}
        {...propsRef}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options.map((item, index) => (
          <option key={index} value={item.value}>
            { item.label }
          </option>
        ))}
      </SelectStyled>
      <SelectIcon>
        <Icon name="chevron-down" color="#B6B6B6"/>
      </SelectIcon>
    </SelectWrapper>
  );
});

Select.propTypes = {
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  width: PropTypes.string,
  fullWidth: PropTypes.bool,
  selected: PropTypes.oneOfType([ PropTypes.string, PropTypes.number]),
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([ PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
  })).isRequired,
  uncontrolled: PropTypes.bool
};

Select.defaultProps = {
  width: '200px'
};
